// @flow
import { createSelector } from "reselect"
import type { InputSelector } from "reselect"
import { Record, List, fromJS } from "immutable"

import * as actions from "./historyActions"
import type { Action } from "./historyActions"

const InitialState = Record({
  urls: List(),
})

function historyReducer(state: InitialState = InitialState(), action: Action) {
  if (!(state instanceof InitialState)) return InitialState(fromJS(state))

  switch (action.type) {
    case actions.PUSH:
      return state.update("urls", urls => urls.push(action.payload.url))

    default:
      return state
  }
}

export default historyReducer

type State = { +history: InitialState }

const getState = state => state.history

export const getLastUrl: InputSelector<State, *, string> = createSelector(
  getState,
  state => state.urls.last(),
)
